import {Component, Key} from "react";
import AxiosUtil from "../../../utils/AxiosUtil";
import {CSVLink} from "react-csv";
import {CloudDownloadOutlined, EditOutlined, SearchOutlined} from "@ant-design/icons";
import {Button, Input, Select, Spin, Table, Form, DatePicker,
    FormInstance, Row, Col, Space, Divider, Typography} from "antd";
import React from "react";
import moment from "moment";
import {TaskProps} from "../model/aireport";
import DataUtil from "../../../utils/DataUtil";

const { RangePicker } = DatePicker;

interface IProps {
    onEdit?: (task: TaskProps) => void,
    onCheck?: (task: TaskProps) => void,
    queryStatus: string,
    queryUser: string
}

interface IState {
    CSVDataList: TaskProps[],
    dataTaskList: TaskProps[],
    dataUserList: any[],
    dataStatusList: any[],
    showLoading: boolean,
    dataYbSum: number,
    selectedTasks: Key[],
    pageIndex: number,
    pageSize: number,
    total: number,
    orderWay: number
}

export default class TaskList extends Component<IProps, IState> {
    queryRef = React.createRef<FormInstance>();

    state = {
        CSVDataList: [],
        dataTaskList: [],
        dataUserList: [],
        dataStatusList: [],
        showLoading: false,
        dataYbSum: 0,
        selectedTasks: [],
        pageIndex: 1,
        pageSize: 10,
        total: 0,
        orderWay: 0
    }

    componentDidMount() {
        //组件加载完成后触发
        this.loadMainData();
        this.loadUserList();
    }

    render() {

        let columns = [
            {
                title: "任务ID",
                key: "id",
                dataIndex: "id",
                align: 'center' as 'center',
                sorter: true,
                // sorter: {compare: (a: any, b: any) => a.id - b.id,},
                // defaultSortOrder: 'ascend' as 'ascend',
            },
            {
                title: "股票代码",
                key: "symbol",
                dataIndex: "symbol",
                align: 'center' as 'center',
                sorter: true
                // sorter: {compare: (a: any, b: any) => a.symbol - b.symbol,}
            },
            {
                title: "股票名称",
                key: "security_name",
                dataIndex: "security_name",
                align: 'center' as 'center',
                sorter: true
                // sorter: {compare: (a: any, b: any) => a.security_name - b.security_name},
            },
            {
                title: "新增研报数",
                key: "ybCount",
                dataIndex: "ybCount",
                align: 'center' as 'center',
                sorter: true
                // sorter: {compare: (a: any, b: any) => a.ybCount - b.ybCount}
            },
            {
                title: "任务分配",
                key: "userName",
                dataIndex: "userName",
                align: 'center' as 'center',
                sorter: true
                // sorter: {compare: (a: any, b: any) => a.userName - b.userName}
            },
            {
                title: "任务日期",
                key: "taskDay",
                dataIndex: "taskDay",
                align: 'center' as 'center',
                sorter: true,
                // sorter: {compare: (a: any, b: any) => a.taskDay - b.taskDay}
                defaultSortOrder: 'descend' as 'descend',
            },
            {
                title: "完成日期",
                key: "finishDay",
                dataIndex: "finishDay",
                align: 'center' as 'center',
                sorter: true
                // sorter: {compare: (a: any, b: any) => a.finishDay - b.finishDay}
            },
            {
                title: "任务状态",
                dataIndex: "param_name",
                align: 'center' as 'center',
                sorter: true
                // sorter: {compare: (a: any, b: any) => a.param_name - b.param_name}
            },
            {
                title: "操作", key: "id1", dataIndex: "id",
                align: 'center' as 'center',
                render: (text: string, row: any) => {
                    return (
                        <Space size="small" split={<Divider type="vertical"/>}>
                            {this.props.onEdit ?
                                <Typography.Link onClick={(e) => onClickEdit(e, row)}>
                                    {row.taskStatus === 1
                                    ? <><EditOutlined/>编辑</>
                                    : <><SearchOutlined/>查看</>}
                                </Typography.Link>
                            : null}
                            {this.props.onCheck ?
                                <Typography.Link onClick={(e) => onClickCheck(e, row)}>
                                    <EditOutlined/> 审核
                                </Typography.Link>
                                : null}
                        </Space>
                    )
                }
            }
        ];
        if (!this.props.onEdit){
            columns.pop();
        }
        const onClickEdit = (e :any,task:TaskProps) => {
            if (this.props.onEdit) {
                this.props.onEdit(task);
            }
        }
        const onClickCheck = (e :any,task:TaskProps) => {
            if (this.props.onCheck) {
                this.props.onCheck(task);
            }
        }

        const csvName = "aireport_tasks_data.csv";
        const csvHeader = [
            {label: "任务ID", key: "id"},
            {label: "股票代码", key: "symbol2"},
            {label: "股票名称", key: "security_name"},
            {label: "新增研报数", key: "ybCount"},
            {label: "任务分配", key: "userName"},
            {label: "任务日期", key: "taskDay"},
            {label: "完成日期", key: "finishDay"},
            {label: "任务状态", key: "param_name"},
        ];

        const {selectedTasks} = this.state;
        const rowSelection = {
            selectedTasks,
            onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
                console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                this.setState({selectedTasks: selectedRowKeys});
            },
            getCheckboxProps: (record: any) => ({
                disabled: record.name === 'Disabled User', // Column configuration not to be checked
                name: record.name,
            }),
        };

        return (
            <Spin tip="Loading..." size="large" spinning={this.state.showLoading}>

                <div id="" style={{marginTop: 15}}>
                    <Form name="AiReport_Form"
                        layout="horizontal"
                        onFinish={this.conditionQuery}
                        ref={this.queryRef}
                        colon={false}
                        className={'query_form'}
                    >
                        <Row gutter={[40, 0]}>
                            <Col span={7}>
                                <Form.Item name={'taskTime'} label={'日期'}  initialValue={[moment().subtract(7, 'days'), moment()]}>
                                    <RangePicker format={"YYYY-MM-DD"} />
                                </Form.Item>
                            </Col>
                            <Col span={4}>
                                <Form.Item name={'taskStatus'} label={'状态'}  initialValue={this.props.queryStatus}>
                                    <Select allowClear={true}>
                                        {DataUtil.selectOptionsRender(this.state.dataStatusList, 'param_code', 'param_name')}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={4}>
                                <Form.Item name={'taskUser'} label={'分配'}  initialValue={this.props.queryUser}>
                                    <Select allowClear={this.props.queryUser===''}>
                                        {DataUtil.selectOptionsRender(this.state.dataUserList, 'user_id', 'user_name')}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={4}>
                                <Form.Item name={'searchText'} label={'股票'}  initialValue={''}>
                                    <Input allowClear={true}></Input>
                                </Form.Item>
                            </Col>
                            <Col span={5}>
                                <Form.Item >
                                    <Space size={16}>
                                        <Button type="primary" htmlType="submit">
                                            <SearchOutlined/>查询
                                        </Button>
                                        <Button type="link" onClick={() => { this.loadMainData(10000) }}>
                                            <CloudDownloadOutlined/> 下载
                                        </Button>
                                        <CSVLink headers={csvHeader}
                                            id="csvLink"
                                            data={this.state.CSVDataList}
                                            filename={csvName}
                                            style={{display: "none"}}
                                        >
                                            <CloudDownloadOutlined/> 下载
                                        </CSVLink>
                                    </Space>
                                </Form.Item>
                            </Col>
                            {/*<Col span={6}>*/}
                            {/*    <Form.Item name={'taskSymbol'} label={'股票代码'}  initialValue={''}>*/}
                            {/*        <Input allowClear={true}></Input>*/}
                            {/*    </Form.Item>*/}
                            {/*</Col>*/}
                            <Col span={8}>
                            </Col>

                            <Col span={4}>
                            </Col>
                        </Row>
                    </Form>
                </div>
                <div id="mainTableDiv">
                    <Table key="t"
                        rowKey="id"
                        rowSelection={{type: 'checkbox', ...rowSelection,}}
                        columns={columns}
                        dataSource={this.state.dataTaskList}
                        pagination={{ onChange: this.pagiChange, total: this.state.total, pageSize: this.state.pageSize, current: this.state.pageIndex}}
                        onChange={async (_pagination, _filters, sorter, _extra)=>{
                            // @ts-ignore
                            const field = sorter.field
                            // @ts-ignore
                            const order = sorter.order
                            console.log(sorter)
                            switch (field) {
                                case 'id': // 根据任务 id 排序
                                    await this.orderBy(order, 12,11); break
                                case 'symbol': // 根据股票代码排序
                                    await this.orderBy(order, 22,21); break
                                case 'security_name': // 根据股票名称排序
                                    await this.orderBy(order, 32,31); break
                                case 'ybCount': // 根据新增研报数量排序
                                    await this.orderBy(order, 42,41); break
                                case 'userName': // 根据 用户ID 排序
                                    await this.orderBy(order, 52,51); break
                                case 'taskDay': // 根据任务日期排序
                                    await this.orderBy(order, 1,0); break
                                case 'finishDay': // 根据完成日期排序
                                    await this.orderBy(order, 62,61); break
                                case 'param_name': // 根据任务状态排序
                                    await this.orderBy(order, 72,71); break
                                default:
                                    await this.orderBy(order, 0,0)
                            }
                        }}
                        scroll={{scrollToFirstRowOnChange: true}}
                        summary={() => (
                            <Table.Summary fixed>
                                <Table.Summary.Row style={{fontWeight: 500}}>
                                    <Table.Summary.Cell index={0} />
                                    <Table.Summary.Cell index={1} align={'center'}>合计</Table.Summary.Cell>
                                    <Table.Summary.Cell index={2} align={'center'}>{this.state.total}</Table.Summary.Cell>
                                    <Table.Summary.Cell index={0} />
                                    <Table.Summary.Cell index={3} align={'center'}>{this.state.dataYbSum}</Table.Summary.Cell>
                                    <Table.Summary.Cell index={0} colSpan={5}/>
                                </Table.Summary.Row>
                            </Table.Summary>
                        )}
                    />
                </div>
            </Spin>
        );
    }

    // 分页页码或每页条数发生变化时调用该函数重新请求数据
    pagiChange = async (page:number, pageSize?:number) => {
        if(this.state.pageSize === pageSize){
            await this.setState({pageIndex: page})
        } else {
            await this.setState({pageIndex: 1, pageSize: pageSize as number})
        }
        // await (this.state.pageSize === pageSize)
        // ? this.setState({pageIndex: page})
        // : this.setState({pageIndex: 1, pageSize: pageSize as number})
        this.loadMainData();
    }
    // 排序函数
    orderBy = async (order: string, ascend: number, descend: number) => {
         switch (order){
            case 'ascend':
                await this.setState({orderWay: ascend}); break
            case 'descend':
                await this.setState({orderWay: descend}); break
            default: await this.setState({orderWay: 0})
        }
        this.loadMainData()
    }
    conditionQuery = async () => {
        await this.setState({pageIndex: 1})
        this.loadMainData()
    }
    loadMainData = (pageSize?: number) => {
        let values = this.queryRef.current?.getFieldsValue();
        // console.log(values);//{taskStatus: "0", taskUser: undefined, taskTime: Array, taskSymbol: "", taskSName: ""}
        let queryParam = {
            pageIndex: pageSize ? 1 : this.state.pageIndex,
            pageSize: pageSize || this.state.pageSize,
            beginTime: values.taskTime[0].format("YYYY-MM-DD"),
            endTime: values.taskTime[1].format("YYYY-MM-DD"),
            userId: values.taskUser,
            taskStatus: values.taskStatus,
            searchText: values.searchText,
            order: this.state.orderWay
        }

        this.setState({showLoading: true,});

        let url = '/api/ybTask/getTask';

        const dataBind = async (suc: boolean, dat: any) => {
            if (suc) {
                for (let i = 0; i < dat.taskList.length; i++) {
                    dat.taskList[i].symbol2 = "'" + dat.taskList[i].symbol;
                }
                await pageSize
                ? this.setState({CSVDataList: dat.taskList})
                : this.setState({dataTaskList: dat.taskList, dataYbSum: dat.sumTask || 0, total: dat.total})
            }
            await this.setState({showLoading: false});
            if(pageSize) document.getElementById('csvLink')?.click()
        }
        AxiosUtil.AxiosRequest(url, queryParam, dataBind);
    }

    loadUserList = () => {
        const dataUsers = (suc: boolean, dat: any) => {
            if (suc) {
                let myData = dat.list;
                if (this.props.queryUser && this.props.queryUser !== '') {
                    myData = myData.filter((el:any) => {return el.user_id === parseInt(this.props.queryUser)});
                }
                for (let i = 0; i < myData.length; i++) {
                    myData[i].names = myData[i].user_name + '（' + myData[i].login_name + '）';
                    myData[i].taskCount = 0;
                }
                this.setState({dataUserList: myData});
            }
        }
        AxiosUtil.AxiosRequest('/api/user/getUser', {pageSize: 100, role_id: 3, rtype: 2}, dataUsers);

        const dataStatus = (suc: boolean, dat: any) => {
            if (suc) {
                this.setState({dataStatusList: dat.list});
            }
        }
        AxiosUtil.AxiosRequest('/api/param/sl', {"parent_id": 167}, dataStatus);
    }
}